<form [formGroup]="entidadeForm" #formElement>
  <div class="row g-2">
    <div class="col-3 form-group my-2">
      <label for="tipoEntidadeId" class="form-label required">Tipo de entidade</label>
      <nz-select formControlName="tipoEntidadeId" nzShowSearch nzAllowClear nzPlaceHolder="Tipo de entidade"
        nzSize="large" [compareWith]="compareFn">
        <nz-option [nzValue]="item?.id" [nzLabel]="item?.nomeTipoEntidade" *ngFor="let item of tipoEntidadeList" />
      </nz-select>
    </div>

    <div class="col-12 col-sm-2 form-group">
      <label for="subTipoEntidadeId" class="form-label required">Sub Tipo de Entidade:</label>
      <nz-select formControlName="subTipoEntidadeId" nzShowSearch nzAllowClear nzPlaceHolder="-" nzSize="large"
        nzPlaceHolder="Pesquise nome do sub tipo de entidade" [compareWith]="compareFn">
        <nz-option [nzValue]="item.id" [nzLabel]="item.nomeSubTipoEntidade" *ngFor="let item of subTipoList" />
      </nz-select>
    </div>

    <div class="col-3 form-group my-2">
      <label for="statusEntidadeId" class="form-label">Situação</label>
      <nz-select formControlName="statusEntidadeId" nzShowSearch nzAllowClear nzPlaceHolder="Situação" nzSize="large"
        [compareWith]="compareFn">
        <nz-option [nzValue]="item?.id" [nzLabel]="item?.nomeStatusEntidade" *ngFor="let item of situacaoList" />
      </nz-select>
    </div>
    <ng-container
      *ngIf="tipoEntidadeIdControl.value == tipoEntidadeEnum?.Comissao || tipoEntidadeIdControl.value == tipoEntidadeEnum?.Subcomissao || tipoEntidadeIdControl.value == tipoEntidadeEnum?.GrupoTrabalho">
      <div class="col-sm-4 ps-5 d-flex align-items-center justify-content-center my-4">
        <div class="form-group">
          <label for="sigilosa" class="form-label">Sigilosa</label>
          <nz-radio-group formControlName="flagEntidadeSigilosa" nzName="radiogroup" style="width: 100%;">
            <label class="mt-1" nz-radio [nzValue]="true">SIM</label>
            <label class="mt-1" nz-radio [nzValue]="false">NÃO</label>
          </nz-radio-group>
        </div>
        <div class="form-group me-4 ms-4">
          <label for="permanente" class="form-label">Permanente</label>
          <nz-radio-group formControlName="flagComissaoPermanente" nzName="radiogroup" style="width: 100%;">
            <label class="mt-1" nz-radio [nzValue]="true">SIM</label>
            <label class="mt-1" nz-radio [nzValue]="false">NÃO</label>
          </nz-radio-group>
        </div>
      </div>
    </ng-container>
    <div class="col-sm-2 form-group my-2 ps-5" *ngIf="!esconderCnpj">
      <label for="empresaEstrangeira" class="form-label">Empresa Estrangeira</label>
      <div class="col-12">
        <nz-radio-group formControlName="flagEmpresaEstrangeira" nzName="radiogroup">
          <label class="mt-1" nz-radio [nzValue]="true">SIM</label>
          <label class="mt-1" nz-radio [nzValue]="false">NÃO</label>
        </nz-radio-group>
      </div>
    </div>
    <div *ngIf="!esconderCnpj && !flagEmpresaEstrangeiraControl.value" class="col-sm-4 form-group my-2">
      <label for="cnpj" class="form-label" [class.required]="cnpjObrigatorio">CNPJ</label>
      <nz-input-group nzSize="large">
        <input nz-input id="cnpj" formControlName="cnpj" placeholder="CNPJ" mask="00.000.000/0000-00"
          (focusout)="onCnpjValid()" />
      </nz-input-group>
    </div>
    <div *ngIf="!esconderCnpj && flagEmpresaEstrangeiraControl.value" class="col-sm-4 form-group my-2">
      <label for="numRegistroEmpresaEstrangeira" class="form-label">Número Registro Empresa Estrangeira</label>
      <nz-input-group nzSize="large">
        <input nz-input id="numRegistroEmpresaEstrangeira" formControlName="numRegistroEmpresaEstrangeira"
          placeholder="Número Registro Empresa Estrangeira" />
      </nz-input-group>
    </div>
    <div class="col-sm-12 form-group my-2">
      <label for="nomeRazaoSocial" class="form-label">Razão Social/Nome</label>
      <nz-input-group nzSize="large">
        <input nz-input id="nomeRazaoSocial" formControlName="nomeRazaoSocial" placeholder="Razão social"
          [maxlength]="200" />
      </nz-input-group>
    </div>
    <div class="col-sm-6 form-group my-2">
      <label for="nomeFantasia" class="form-label required">Nome Fantasia/Nome Reduzido</label>
      <nz-input-group nzSize="large">
        <input nz-input id="nomeFantasia" formControlName="nomeFantasia" placeholder="Nome da entidade"
          [maxlength]="200" />
      </nz-input-group>
    </div>
    <div class="col-sm-6 form-group">
      <label for="dataControleAtualizacao" class="form-label">Data de Controle de Atualização</label>
      <nz-date-picker id="dataControleAtualizacao" [nzFormat]="'dd/MM/YYYY'" [nzSize]="'large'"
        formControlName="dataControleAtualizacao" (input)="onInputDateChange($event, 'dataControleAtualizacao')"
        [nzAllowClear]="true"></nz-date-picker>
    </div>
    <ng-container
      *ngIf="tipoEntidadeIdControl.value == tipoEntidadeEnum?.Comissao || tipoEntidadeIdControl.value == tipoEntidadeEnum?.Subcomissao || tipoEntidadeIdControl.value == tipoEntidadeEnum?.GrupoTrabalho || tipoEntidadeIdControl.value == tipoEntidadeEnum?.Orgao">
      <div class="col-6 form-group my-2">
        <label for="usuarioAprovador" class="form-label">Usuário Aprovador</label>
        <nz-select formControlName="usuarioAprovador" nzShowSearch nzAllowClear nzPlaceHolder="Situação" nzSize="large"
          [compareWith]="compareFn">
          <nz-option [nzValue]="item?.id" [nzLabel]="item?.nome" *ngFor="let item of perfisAprovador" />
        </nz-select>
      </div>
      <div class="col-6 form-group my-2">
        <label for="emailAprovador" class="form-label">Email Aprovador</label>
        <app-email-search-select formControlName="emailAprovador" placeholder="E-mail do Aprovador"></app-email-search-select>
      </div>
    </ng-container>

    <ng-container
      *ngIf="tipoEntidadeIdControl.value == tipoEntidadeEnum?.Orgao || tipoEntidadeIdControl.value == tipoEntidadeEnum?.Comissao || tipoEntidadeIdControl.value == tipoEntidadeEnum.Subcomissao || tipoEntidadeIdControl.value == tipoEntidadeEnum.GrupoTrabalho || tipoEntidadeIdControl.value == tipoEntidadeEnum.Area">
      <div class="col-sm-4 form-group my-2">
        <label for="entidadePertenceId" class="form-label">Pertence a:</label>
        <nz-select formControlName="entidadePertenceId" nzShowSearch nzAllowClear nzPlaceHolder="Pertence a"
          nzSize="large" [compareWith]="compareFn">
          <nz-option [nzValue]="item.id" [nzLabel]="item.nomeFantasia" *ngFor="let item of entidadesPertenceList" />
        </nz-select>
      </div>
    </ng-container>
    <ng-container *ngIf="mostrarRepresentacao">
      <div class="col-sm-6 form-group my-2">
        <label for="representacaoId" class="form-label">Representação</label>
        <nz-select formControlName="representacaoId" nzShowSearch nzAllowClear nzPlaceHolder="Representação"
          nzSize="large" [compareWith]="compareFn" (ngModelChange)="onRepresentacaoChange($event)">
          <nz-option [nzValue]="item.id" [nzLabel]="item.nomeRepresentacao" *ngFor="let item of representacaoList" />
        </nz-select>
      </div>

      <ng-container *ngIf="mostrarRepresentacaoNacional">
        <div class="col-sm-3 form-group">
          <label for="tipoAssociacao" class="form-label" [class.required]="tipoAssociacaoObrigatorio">Tipo
            Associação</label>
          <nz-select formControlName="tipoAssociacao" nzShowSearch nzAllowClear nzPlaceHolder="-" nzSize="large"
            [compareWith]="compareFn"
            [nzStatus]="mostrarErroTipoAssociacao ? 'error' : ''">
            <nz-option [nzValue]="item.codigo" [nzLabel]="item.nome" *ngFor="let item of tipoAssociadaList" />
          </nz-select>
          <span class="text-danger small" *ngIf="mostrarErroTipoAssociacao">Campo obrigatório</span>
        </div>
      </ng-container>
    </ng-container>

    <!-- <ng-container
      *ngIf="tipoEntidadeIdControl.value == tipoEntidadeEnum?.Comissao || tipoEntidadeIdControl.value == tipoEntidadeEnum?.Subcomissao || tipoEntidadeIdControl.value == tipoEntidadeEnum?.GrupoTrabalho">
      <div class="col-sm-4 form-group my-2">
        <label for="tipoComissaoId" class="form-label">Tipo de Comissão</label>
        <nz-select formControlName="tipoComissaoId" nzShowSearch nzAllowClear nzPlaceHolder="Tipo de Comissão"
          nzSize="large" [compareWith]="compareFn">
          <nz-option [nzValue]="item.id" [nzLabel]="item.nomeTipoComissao" *ngFor="let item of tipoComissaoList" />
        </nz-select>
      </div>

    </ng-container> -->
    <ng-container
      *ngIf="tipoEntidadeIdControl.value == tipoEntidadeEnum?.Comissao || tipoEntidadeIdControl.value == tipoEntidadeEnum.Subcomissao || tipoEntidadeIdControl.value == tipoEntidadeEnum.GrupoTrabalho || tipoEntidadeIdControl.value == tipoEntidadeEnum.Orgao">
      <div class="col-sm-4 form-group my-2">
        <label for="entidadeAdministradora" class="form-label">Entidade Administradora</label>
        <nz-select formControlName="entidadeAdministradoraId" (nzOnSearch)="loadEntidadesAdministradoras($event)"
          nzShowSearch nzAllowClear nzPlaceHolder="Entidade Administradora" nzSize="large" [compareWith]="compareFn">
          <nz-option [nzValue]="item.id" [nzLabel]="item.nome" *ngFor="let item of entidadeAdministradoraList" />
        </nz-select>
      </div>
      <div class="col-sm-4 form-group my-2">
        <label for="pessoaAdminstradoraId" class="form-label">Pessoa Administradora</label>
        <nz-select formControlName="pessoaAdminstradoraId" nzShowSearch nzAllowClear
          nzPlaceHolder="Pessoa Administradora" nzSize="large" [compareWith]="compareFn">
          <nz-option [nzValue]="item.id" [nzLabel]="item.nomeConhecido" *ngFor="let item of pessoaAdministradoraList" />
        </nz-select>
      </div>
    </ng-container>
    <ng-container *ngIf="mostrarEntidadesAfins">
      <div class="col-sm-4 form-group my-2">
        <label for="entidadeAfins" class="form-label">Entidades Afins</label>
        <nz-select formControlName="entidadeAfins" nzShowSearch nzAllowClear nzPlaceHolder="Entidades Afins"
          nzSize="large" [compareWith]="compareFn" nzMode="multiple">
          <nz-option [nzValue]="item.id" [nzLabel]="item.nome" *ngFor="let item of entidadeAfinsList" />
        </nz-select>
      </div>
    </ng-container>
    <ng-container
      *ngIf="tipoEntidadeIdControl.value == tipoEntidadeEnum?.Seguradora || tipoEntidadeIdControl.value == tipoEntidadeEnum.Saude || tipoEntidadeIdControl.value == tipoEntidadeEnum.Capitalizacao|| tipoEntidadeIdControl.value == tipoEntidadeEnum?.Previdencia">
      <div class="col-sm-3 form-group">
        <label for="codigoReguladora" class="form-label">Código Reguladora</label>
        <nz-input-group nzSize="large">
          <input nz-input id="codigoReguladora" formControlName="codigoReguladora" placeholder="Código Reguladora"
            type="text" />
        </nz-input-group>
        <ng-template #nomeTemplate>
          <span class="fs-5 me-2 clarity--user-solid"></span>
        </ng-template>
      </div>
      <div class="col-sm-3 form-group">
        <label for="tipoReguladoraId" class="form-label">Reguladora</label>
        <nz-select formControlName="tipoReguladoraId" nzShowSearch nzAllowClear nzPlaceHolder="-" nzSize="large"
          [compareWith]="compareFn">
          <nz-option [nzValue]="item.id" [nzLabel]="item.nomeTipoReguladora" *ngFor="let item of tipoReguladoraList" />
        </nz-select>
      </div>

      <ng-container *ngIf="mostrarSegmentacao">
        <div class="col-sm-3 form-group">
          <label for="segmentacao" class="form-label">Segmentação</label>
          <nz-select formControlName="segmentacao" nzShowSearch nzAllowClear nzPlaceHolder="-" nzSize="large"
            [compareWith]="compareFn">
            <nz-option [nzValue]="item.codigo" [nzLabel]="item.nome" *ngFor="let item of segmentacaoList" />
          </nz-select>
        </div>

      </ng-container>

    </ng-container>
    <ng-container
      *ngIf="tipoEntidadeIdControl.value == tipoEntidadeEnum?.Seguradora || tipoEntidadeIdControl.value == tipoEntidadeEnum.Saude || tipoEntidadeIdControl.value == tipoEntidadeEnum.Capitalizacao || tipoEntidadeIdControl.value == tipoEntidadeEnum.Previdencia">
      <div class="col-sm-4 form-group my-2">
        <label for="grupoEconomicoId" class="form-label">Grupo Econômico</label>
        <nz-select formControlName="grupoEconomicoId" nzShowSearch nzAllowClear nzPlaceHolder="Grupo Econômico"
          nzSize="large" [compareWith]="compareFn">
          <nz-option [nzValue]="item.id" [nzLabel]="item.nomeGrupoEconomico" *ngFor="let item of grupoEconomicoList" />
        </nz-select>
      </div>
    </ng-container>
    <!-- <ng-container *ngIf="tipoEntidadeIdControl.value == tipoEntidadeEnum?.Previdencia">
      <div class="col-sm-3 form-group">
        <label for="codigoReguladora" class="form-label"> Código Reguladora</label>
        <nz-input-group nzSize="large">
          <input nz-input id="codigoReguladora" formControlName="codigoReguladora" placeholder="Código Reguladora" />
        </nz-input-group>
        <ng-template #nomeTemplate>
          <span class="fs-5 me-2 clarity--user-solid"></span>
        </ng-template>
      </div>
    </ng-container> -->
    <ng-container *ngIf="mostrarGrupoAtualiacao">
      <div class="col-sm-4 form-group my-2">
        <label for="grupoAtualizacaoId" class="form-label">Grupo de Atualização</label>
        <nz-select formControlName="grupoAtualizacaoId" nzShowSearch nzAllowClear nzPlaceHolder="Grupo de Atualização"
          nzSize="large" [compareWith]="compareFn">
          <nz-option [nzValue]="item.id" [nzLabel]="item.nomeGrupoAtualizacao"
            *ngFor="let item of grupoAtualizacaoList" />
        </nz-select>
      </div>
    </ng-container>
    <ng-container
      *ngIf="tipoEntidadeIdControl.value == tipoEntidadeEnum?.Comissao || tipoEntidadeIdControl.value == tipoEntidadeEnum?.Orgao || tipoEntidadeIdControl.value == tipoEntidadeEnum.Subcomissao || tipoEntidadeIdControl.value == tipoEntidadeEnum.GrupoTrabalho || tipoEntidadeIdControl.value == tipoEntidadeEnum.Area">
      <div class="col-sm-4 form-group d-flex align-items-end mb-3 ps-4">
        <label nz-checkbox formControlName="anosMandato">Possui Mandato</label>
      </div>
    </ng-container>

  </div>
</form>

<ng-container *ngIf="anosMandatoControl?.value">
  <section class="row align-items-center">
    <div class="col mt-3">
      <div class="d-flex align-items-center justify-content-between">
        <p class="fw-bold text-primary-color">Mandatos</p>
        <i class="fi fi-rs-bank"></i>
      </div>
      <nz-divider class="m-0 p-0 divider-primary-color"></nz-divider>
      <div class="col-12 py-3">
        <app-mandato-list [entidadeForm]="entidadeForm" [paginaEntidade]="true" [data]="entidade"
          [somenteVisualizar]="somenteVisualizar"></app-mandato-list>
      </div>
    </div>
  </section>
</ng-container>

<!-- <ng-container *ngIf="isOrgao() || isComissao() || isSubcomissao() || isGrupoTrabalho()"> -->
<section class="row align-items-center mt-3">
  <div class="col mt-3">
    <div class="d-flex align-items-center justify-content-between">
      <p class="fw-bold text-primary-color">Cargos</p>
      <i class="fi fi-rs-bank"></i>
    </div>
    <nz-divider class="m-0 p-0 divider-primary-color"></nz-divider>
    <div class="col-12">
      <!-- <app-cargo-list [entidadeForm]="entidadeForm" [entidade]="entidade"
          [somenteVisualizar]="somenteVisualizar"></app-cargo-list> -->
      <app-lista-niveis-drag-and-drop [dataSet]="dataSetHierarquia" [tipoEntidadePadrao]="tipoEntidadeIdValue"
        [subTipoPadrao]="subTipoValue" [incluirInativos]="incluirInativos" (atualizarDados)="atualizarEstrutura($event)"
        (salvar)="salvarItem($event)" (editar)="editarItem($event)" (remover)="removerItem($event)"
        (reativar)="reativarItem($event)" (resetHierarquia)="resetHierarquia($event)" [habilitarBotoesExtras]="true"
        [entidade]="true">
      </app-lista-niveis-drag-and-drop>
    </div>
  </div>
</section>
<!-- </ng-container> -->

<section class="row align-items-center mt-3">
  <div class="col mt-3">
    <div class="d-flex align-items-center justify-content-between">
      <p class="fw-bold text-primary-color">Entidade Superior</p>
      <i class="fi fi-rs-bank"></i>
    </div>
    <nz-divider class="m-0 p-0 divider-primary-color"></nz-divider>
    <div class="col-12 py-4">
      <app-entidade-superior-list [entidadeForm]="entidadeForm" [tipoEntidadeSelecionada]="tipoEntidadeIdControl.value"
        [tipoEntidadeList]="tipoEntidadeList" [tipoRelacaoList]="tipoRelacaoList" [inserir]="inserir"
        [somenteVisualizar]="somenteVisualizar" [nomePagina]="nomePagina"></app-entidade-superior-list>
    </div>
  </div>
</section>
